import { useNode } from '@craftjs/core';
import { cn } from '../../../../lib/utils';

interface CodeBlockProps {
  code: string;
  language: string;
}

export function CodeBlock({ code, language }: CodeBlockProps) {
  const {
    connectors: { connect, drag },
    selected,
    actions: { setProp },
  } = useNode((state) => ({
    selected: state.events.selected,
  }));

  return (
    <div
      ref={(ref) => {
        if (ref) connect(drag(ref));
      }}
      className={cn(
        'rounded transition-all overflow-hidden',
        selected && 'ring-2 ring-primary ring-offset-2'
      )}
    >
      <div className="flex items-center justify-between bg-zinc-800 px-4 py-2">
        <span className="text-xs text-zinc-400 font-mono">{language || 'código'}</span>
      </div>
      <pre className="bg-zinc-900 p-4 overflow-x-auto">
        <code
          contentEditable={selected}
          suppressContentEditableWarning
          className="text-sm text-zinc-100 font-mono outline-none whitespace-pre"
          onBlur={(e) => {
            setProp((props: CodeBlockProps) => {
              props.code = e.currentTarget.textContent || '';
            });
          }}
        >
          {code || (selected ? '// Cole seu código aqui' : '')}
        </code>
      </pre>
    </div>
  );
}

CodeBlock.craft = {
  displayName: 'Código',
  props: {
    code: '',
    language: 'javascript',
  },
  rules: { canDrag: () => true },
};
